module.exports = __webpack_public_path__ + "static/media/hero-audiences.88a4310c.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/winter-2019/hero-audiences.png
// module id = 49
// module chunks = 0